<script setup>
// §8.1 AppFrame — the shell. 5px brand hairline, canvas, sidebar + main.
// The frame is one of the few things allowed to float (elevation, §4).
// Slots: sidebar (SideNav + UserFooter), default (the page).
</script>

<template>
	<div class="l-appframe">
		<div class="hairline" aria-hidden="true"></div>
		<div class="body">
			<aside class="side" data-section="app-sidebar">
				<slot name="sidebar" />
			</aside>
			<main class="main" data-section="app-main">
				<slot />
			</main>
		</div>
	</div>
</template>

<style scoped>
.l-appframe
{
	height: 100%;
	display: flex;
	flex-direction: column;
	background: var(--canvas-inset);
	/* border-radius: var(--r-xl); */	/* No. Looks stupid. */
	overflow: hidden;
	box-shadow: var(--shadow);
}

.hairline
{
	flex: none;
	height: 5px;
	background: var(--brand);
}

.body
{
	display: flex;
	/* min-height: 720px; */

	flex: 1 1 0%;
	min-height: 0;
}

.side
{
	width: 280px;
	flex: none;
	background: var(--surface);
	border-right: 1px solid var(--line);
	display: flex;
	flex-direction: column;
	min-height: 0;
}

.main
{
	flex: 1;
	min-width: 0;
	padding: var(--sp-6) var(--sp-7);
	overflow-y: auto;
}

@media (max-width: 720px)
{
	.body
	{
		flex-direction: column;
	}

	.side
	{
		width: 100%;
		border-right: 0;
		border-bottom: 1px solid var(--line);
	}
}
</style>
